module.exports = __webpack_public_path__ + "img/Frame 2.347a2252.png";